export var CLOSE_ON_LEAVE_THRESHOLD = 500;
export var STYLE_NAMESPACE = 'vcp-context-menu';
export var STYLE_NAMESPACES = 'vcp-context-menu';
